import React, { Component, Fragment } from 'react';
import About from './About';
import Banner from './Banner';
import Blog from './Blog';
import Cta from './Cta';
import Features from './Features';
import Portfolio from './Portfolio';
import Services from './Services';
import Testimonial from './Testimonial';

class Content extends Component {
    render() {
        return (
            <Fragment>
                <Banner/>
                <About/>
                <Features/>
                <Services/>
                <Cta/>
                <Portfolio/>
                <Testimonial/>
                <Blog/>
            </Fragment>
        );
    }
}

export default Content;